module.exports = __webpack_public_path__ + "img/product_2.b6e6534.jpg";